import { render, staticRenderFns } from "./LinkUserWorkspace.vue?vue&type=template&id=32a18bdb"
import script from "./LinkUserWorkspace.vue?vue&type=script&lang=js"
export * from "./LinkUserWorkspace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports